import _ from 'lodash';
import createReactClass from 'create-react-class';
import Morearty from 'morearty';
import React from 'react';
import PropTypes from 'prop-types';

import DateRangeFilter from 'components/lib/date_range_filter';
import ProvidersMixin from 'components/lib/providers_mixin';
import SharedBindingsMixin from 'components/lib/shared_bindings_mixin';
import i18n from 'scripts/i18n/i18n';

const DateUpdatedFilterContainer = createReactClass({
  mixins: [Morearty.Mixin, ProvidersMixin, SharedBindingsMixin],

  propTypes: {
    onChange: PropTypes.func,
    queryId: PropTypes.string,
  },

  UNSAFE_componentWillMount() {
    this.observeBinding(this.getSharedBinding('universalSearchResults'));
  },

  render() {
    let props = {};
    let result = this.getProvider('universalSearchResults').findBy({ id: this.props.queryId });
    let updatedAt = _.get(result, 'query.filter.updatedAt');
    if (updatedAt) {
      props.startDate = updatedAt.gte;
      props.endDate = updatedAt.lte;
    }

    return (
      <DateRangeFilter
        {...props}
        className="universalSearch-filter-dateUpdated"
        isDateTimePicker
        onApply={this.onApply}
        onClear={this.onClear}
        position="right"
        renderPlaceholder={this.renderPlaceholder}
      />
    );
  },

  renderPlaceholder() {
    return <div className="universalSearch-filter-dateUpdated-placeholder">{i18n.t('Last Updated')}</div>;
  },

  onApply({ startDate, endDate }) {
    if (this.props.onChange) {
      this.props.onChange({ updatedAt: { gte: startDate, lte: endDate } });
    }
  },

  onClear() {
    if (this.props.onChange) {
      this.props.onChange({ updatedAt: null });
    }
  },
});

export default DateUpdatedFilterContainer;
